import axios from 'axios'

export const ContactsService = {
    loadContacts: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/contacts')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    deleteContact: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/contacts/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    updateContact: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/contacts/' + payload.id, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    createContact: (payload) => {
        return new Promise(
            function (resolve, reject) {
                let json = {
                    contacts: [
                        payload
                    ]
                }
                axios.post('/contacts', json)
                    .then((response) => {
                        if (response.status === 201) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    saveContacts: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/contacts', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    deleteAllContacts: () => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/contacts')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/contacts-service.js